/**
 * 用户状态管理模块
 * 负责：Token 管理、用户信息存储、登录/登出逻辑
 */

const state = {
  // 认证 Token
  token: localStorage.getItem('token') || null,
  
  // 用户信息对象
  userInfo: JSON.parse(localStorage.getItem('userInfo')) || null
}

const getters = {
  /**
   * 是否已登录
   */
  isLoggedIn: state => !!state.token,
  
  /**
   * 用户名
   */
  userName: state => state.userInfo?.nickname || state.userInfo?.name || '',
  
  /**
   * 用户头像
   */
  userAvatar: state => state.userInfo?.avatar || ''
}

const mutations = {
  /**
   * 设置 Token
   * @param {State} state 
   * @param {string} token 
   */
  SET_TOKEN(state, token) {
    state.token = token
    localStorage.setItem('token', token)
  },
  
  /**
   * 清除 Token
   * @param {State} state 
   */
  CLEAR_TOKEN(state) {
    state.token = null
    localStorage.removeItem('token')
  },
  
  /**
   * 设置用户信息
   * @param {State} state 
   * @param {Object} userInfo 
   */
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  },
  
  /**
   * 清除用户信息
   * @param {State} state 
   */
  CLEAR_USER_INFO(state) {
    state.userInfo = null
    localStorage.removeItem('userInfo')
  }
}

const actions = {
  /**
   * 登录操作（调用后端接口后调用此 action）
   * @param {Object} context 
   * @param {Object} payload 
   * @param {string} payload.token - 后端返回的 token
   * @param {Object} payload.user_info - 后端返回的用户信息
   */
  login({ commit }, { token, user_info }) {
    return new Promise((resolve, reject) => {
      try {
        commit('SET_TOKEN', token)
        commit('SET_USER_INFO', user_info)
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  },
  
  /**
   * 登出操作
   * @param {Object} context 
   */
  logout({ commit }) {
    return new Promise((resolve) => {
      commit('CLEAR_TOKEN')
      commit('CLEAR_USER_INFO')
      resolve()
    })
  },
  
  /**
   * 获取当前用户信息（从本地存储读取）
   * @param {Object} context 
   */
  getUserInfo({ state }) {
    return Promise.resolve(state.userInfo)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
